import React from 'react';
import { useAppContext } from '../context/AppContext';
import { Table, Image, Text } from '@mantine/core';

const IMAGE_URL = import.meta.env.VITE_S3_PNG_URL;

const PlantShoppingListMobile = () => {
	const { currentDesign, filteredList } = useAppContext().state;
	const { chosenPlants } = currentDesign;

	return (
		<Table striped highlightOnHover withTableBorder withColumnBorders style={{ width: '100%', fontSize: '12px', tableLayout: 'fixed' }}>
			<Table.Thead>
				<Table.Tr>
					<Table.Th style={{ width: '16%', padding: '4px', textAlign: 'center' }}>Image</Table.Th>
					<Table.Th style={{ width: '16%', padding: '4px', textAlign: 'center' }}>Category</Table.Th>
					<Table.Th style={{ width: '10%', padding: '4px', textAlign: 'center' }}>Qty</Table.Th>
					<Table.Th style={{ width: '32%', padding: '4px' }}>Common Name</Table.Th>
					<Table.Th style={{ width: '26%', padding: '4px' }}>Botanical Name</Table.Th>
				</Table.Tr>
			</Table.Thead>
			<Table.Tbody>
				{chosenPlants.map(({ plantId, category, quantity }) => {
					const plantInfo = filteredList.find((plant) => plant.ID === plantId);
					if (!plantInfo) return null;

					return (
						<Table.Tr key={`${plantId}-${category}`}>
							<Table.Td style={{ width: '16%', padding: "1vw", textAlign: 'center' }}>
								<Image
									src={`${IMAGE_URL}/${plantInfo.ImageURL}.png`}
									alt={plantInfo.Common}
									width={"auto"}
									height={"auto"}
									fit="contain"
								/>
							</Table.Td>
							<Table.Td style={{ width: '16%', padding: '4px', textAlign: 'center' }}>
								<Text size="xs">{category}</Text>
							</Table.Td>
							<Table.Td style={{ width: '10%', padding: '4px', textAlign: 'center' }}>
								<Text size="xs">{quantity}</Text>
							</Table.Td>
							<Table.Td style={{ width: '32%', padding: '4px' }}>
								<Text size="xs" style={{ wordBreak: 'break-word' }}>{plantInfo.Common}</Text>
							</Table.Td>
							<Table.Td style={{ width: '26%', padding: '4px' }}>
								<Text size="xs" fs="italic" style={{ wordBreak: 'break-word' }}>{plantInfo.Botanical}</Text>
							</Table.Td>
						</Table.Tr>
					);
				})}
			</Table.Tbody>
		</Table>
	);
};

export default PlantShoppingListMobile;
